import React, { FC } from 'react'
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: theme.spacing(144),
    height: theme.spacing(32),
  },
  title: {
    backgroundColor: theme.palette.grey[50],
    textTransform: 'capitalize',
  },
  mgTop: {
    marginTop: theme.spacing(6),
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}))

interface RequestQuotationProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const RequestQuotationPopup: FC<RequestQuotationProps> = (props) => {
  const classes = useStyles()
  const { dialogOpen, setDialogOpen } = props

  const handleClose = (): void => {
    setDialogOpen(false)
  }

  return (
    <div className={dialogOpen ? classes.root : ''}>
      <Dialog onClose={handleClose} open={dialogOpen}>
        <DialogTitle className={classes.title}>
          <FormattedMessage {...messages.CONTACT_CUSTOMER_SERVICE} />
        </DialogTitle>
        <IconButton
          className={classes.clearButton}
          color="primary"
          onClick={handleClose}
        >
          <ClearIcon />
        </IconButton>
        <DialogContent className={clsx(classes.root, classes.mgTop)}>
          <FormattedMessage {...messages.REQUEST_QUOTATION_TEXT} />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default RequestQuotationPopup
